import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.function.bind";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import React from "react";
import ClassNames from "classnames";
import SubpageContainer from "../subpage/container";
import SubpageNavigation from "../subpage/navigation";
import SubpagePager from "../subpage/pager";

var PaginatedLayout =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PaginatedLayout, _React$Component);

  function PaginatedLayout(props, state) {
    var _this;

    _classCallCheck(this, PaginatedLayout);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PaginatedLayout).call(this, props, state));
    _this.state = {
      navItems: [],
      hasSubpages: false
    };
    _this.onClickNavItem = _this.onClickNavItem.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(PaginatedLayout, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$state = this.state,
          navItems = _this$state.navItems,
          hasSubpages = _this$state.hasSubpages;

      if (Array.isArray(this.props.children)) {
        var locationHash = this.props.location.hash.replace("#", "");
        var hasLocationHash = !!locationHash;
        var isFirst = true;
        this.props.children.forEach(function (child, index) {
          if (child.props.mdxType === "Subpage") {
            hasSubpages = true;
            var isActive = false;

            if (hasLocationHash && locationHash === child.props.slug) {
              isActive = true;
            } else if (!hasLocationHash && isFirst) {
              isActive = true;
            }

            navItems.push({
              slug: child.props.slug,
              title: child.props.children[0].props.children,
              children: child.props.children,
              isActive: isActive
            });
          }

          isFirst = false;
        });
      } else if (this.props.children.props.mdxType === "Subpage") {
        hasSubpages = true;
        navItems.push({
          slug: this.props.children.props.slug,
          title: this.props.children.props.children[0].props.children,
          children: this.props.children.props.children,
          isActive: true
        });
      }

      this.setState({
        navItems: navItems,
        hasSubpages: hasSubpages
      });
    }
  }, {
    key: "getActiveItem",
    value: function getActiveItem() {
      var activeItem = {
        slug: null
      };
      var previous = {
        slug: null
      };
      var next = {
        slug: null
      };
      var navItems = this.state.navItems;
      navItems.forEach(function (item, i) {
        if (item.isActive) {
          activeItem = item;
          previous = i > 0 ? navItems[i - 1] : {
            slug: null
          };
          next = i < navItems.length - 1 ? navItems[i + 1] : {
            slug: null
          };
        }
      });
      return {
        activeItem: activeItem,
        previous: previous,
        next: next
      };
    }
  }, {
    key: "onClickNavItem",
    value: function onClickNavItem(e, slug) {
      var _this2 = this;

      e.preventDefault();
      var navItems = this.state.navItems;

      if (navItems.length < 1) {
        return;
      } // Loop through nav items to set the appropriate item as active (and others not)


      navItems.forEach(function (item, index) {
        item.isActive = slug === item.slug;
      });
      this.setState({
        navItems: navItems
      }, function () {
        _this2.props.onClickNavItem(slug);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          number = _this$props.number,
          cover = _this$props.cover,
          children = _this$props.children;
      var _this$state2 = this.state,
          navItems = _this$state2.navItems,
          hasSubpages = _this$state2.hasSubpages;
      var activeItem = this.getActiveItem();
      var numberString = number ? "Lesson ".concat(number, ": ") : "";
      var pageNameClasses = ClassNames("l-page-name t-display-2");
      var mainClasses = ClassNames("l-main", {
        "l-main--lesson": hasSubpages,
        "l-main--page": !hasSubpages
      });
      var mainStyles = {
        "--cover": "url(\"".concat(cover, "/1600x1600\")")
      };
      return React.createElement("main", {
        className: mainClasses,
        style: mainStyles
      }, React.createElement("h2", {
        className: pageNameClasses
      }, numberString, title), React.createElement(SubpageNavigation, {
        hasSubpages: hasSubpages,
        subpages: navItems,
        onClickNavItem: this.onClickNavItem
      }), React.createElement(SubpageContainer, {
        hasSubpages: hasSubpages,
        subpages: navItems
      }, children), React.createElement(SubpagePager, {
        hasSubpages: hasSubpages,
        nextPageSlug: activeItem.next.slug,
        prevPageSlug: activeItem.previous.slug,
        onClickPager: this.onClickNavItem
      }));
    }
  }]);

  return PaginatedLayout;
}(React.Component);

;
export default PaginatedLayout;